import { addDays } from "date-fns";
import { map } from "rxjs";
import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../common/searchParams.utils";
import { AdminPaymentRecaudoSearch } from "./AdminPaymentRecaudoSearch";
import { AdminPaymentRecaudoTable } from "./AdminPaymentRecaudoTable";
import { AdminPaymentRecaudoParams } from "./AdminPaymentRecaudo.interface";

export const AdminPaymentRecaudoResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: AdminPaymentRecaudoParams) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const from_date = getDateAttribute(params.from_date);
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));
      const payment_status_option = getAttributeList(
        params.payment_status_option
      );
      const cashback_status_option = getAttributeList(
        params.cashback_status_option
      );
      const bank_type = getAttributeList(params.bank_type);
      return {
        ...params,
        volante_nums,
        from_date,
        to_date,
        payment_status_option,
        cashback_status_option,
        bank_type,
      };
    })
  );
  return (
    <div>
      <AdminPaymentRecaudoSearch params$={params$} />
      <AdminPaymentRecaudoTable params$={params$} />
    </div>
  );
};
